import httpClient from '@/utilities/service/httpClient'
import AbstractApi from '@/api/abstracts/AbstractApi'
import AnalysisPeriodApi from '@/api/services/sales/bid/spec/analysis/period/AnalysisPeriodApi'
import { AnalysisPeriodEnum } from '@/api/enums/AnalysisPeriodEnum'
// types
import { AnalyseId, SiteId } from '@/api/types/general/GeneralType'
import { AnalysisDeletedType, AnalysisType, AllPeriodsDeletedType } from '@/api/types/response/AnalysisType'
import { CreateAnalysisPayloadType, UpdateAnalysisPayloadType } from '@/api/types/request/AnalysisPayloadType'

/**
 * @property string apiEnd /api/sales/bid/spec/{bidNumber}
 */
export default class AnalysisApi extends AbstractApi {
  fetch(siteId: SiteId): Promise<AnalysisType> {
    return httpClient.get(`${this.apiEnd}/${siteId}/analysis`)
  }

  fetchAll(): Promise<AnalysisType> {
    return httpClient.get(`${this.apiEnd}/analysis`)
  }

  add(siteId: SiteId, payload: CreateAnalysisPayloadType): Promise<AnalysisType> {
    return httpClient.post(`${this.apiEnd}/${siteId}/analysis`, payload)
  }

  edit(id: number, siteId: SiteId, payload: UpdateAnalysisPayloadType): Promise<AnalysisType> {
    return httpClient.put(`${this.apiEnd}/${siteId}/analysis/${id}`, payload)
  }

  delete(siteId: SiteId, id?: number): Promise<AnalysisDeletedType> {
    return id ? this.deleteOne(siteId, id) : this.deleteAll(siteId)
  }

  deleteOne(siteId: SiteId, id: number): Promise<AnalysisDeletedType> {
    return httpClient.delete(`${this.apiEnd}/${siteId}/analysis/${id}`)
  }

  deleteAll(siteId: SiteId): Promise<AnalysisDeletedType> {
    return httpClient.delete(`${this.apiEnd}/${siteId}/analysis`)
  }

  period<T extends keyof typeof AnalysisPeriodEnum = AnalysisPeriodEnum.analysis>(
    siteId: SiteId,
    analysis: AnalyseId,
    type: T,
  ): AnalysisPeriodApi<T> {
    return new AnalysisPeriodApi<T>(`${this.apiEnd}/${siteId}/analysis/${analysis}/${type}`)
  }

  deleteAllPeriods(siteId: SiteId): Promise<AllPeriodsDeletedType> {
    return httpClient.delete(`${this.apiEnd}/${siteId}/analysis/periods`)
  }
}
